import type { LocationRepository } from '@/core/location'
import type { UseCase } from '@/core/shared'

export const createLocation: UseCase<LocationRepository, 'createLocation'> = repository => {
  return async (location) => {
    return await repository.createLocation(location)
  }
}
